import React from "react";

const fmt = new Intl.NumberFormat("en-US");

export default function ResumenGeneral({ datos }) {
    const totalMinutos =
        Number(datos?.minutos_movil || 0) +
        Number(datos?.minutos_fijo || 0) +
        Number(datos?.minutos_pais || 0);

    const totalLlamadas =
        Number(datos?.llamadas_movil || 0) +
        Number(datos?.llamadas_fijo || 0) +
        Number(datos?.llamadas_pais || 0);

    const items = [
        { label: "Llamadas fijo", value: datos?.llamadas_fijo ?? 0, color: "text-blue-600" },
        { label: "Minutos fijo", value: datos?.minutos_fijo ?? 0, color: "text-blue-600", tarifa: datos?.tarifa_fijo },

        { label: "Llamadas móvil", value: datos?.llamadas_movil ?? 0, color: "text-emerald-600" },
        { label: "Minutos móvil", value: datos?.minutos_movil ?? 0, color: "text-emerald-600", tarifa: datos?.tarifa_movil },

        { label: "Llamadas entrantes", value: datos?.llamadas_entrada ?? 0, color: "text-rose-600" },
        { label: "Minutos entrantes", value: datos?.minutos_entrada ?? 0, color: "text-rose-600" },

        { label: "Llamadas país", value: datos?.llamadas_pais ?? 0, color: "text-slate-600" },
        { label: "Minutos país", value: datos?.minutos_pais ?? 0, color: "text-slate-600", tarifa: datos?.tarifa_pais },

        { label: "Total de minutos", value: totalMinutos, color: "text-amber-600", highlight: true },
        { label: "Total de llamadas", value: totalLlamadas, color: "text-amber-600", highlight: true },

        { label: "Buzón", value: datos?.buzon ?? 0, color: "text-gray-900", tarifa: datos?.tarifa_buzon },
    ];

    return (
        <div className="bg-white p-3 md:p-4 rounded-xl shadow-md mb-4">
            <h2 className="text-sm md:text-base font-semibold text-gray-700 mb-2">
                Resumen general
            </h2>

            {/* En móvil envuelve en 2 columnas (sin scroll horizontal que empuje la página) */}
            <div className="w-full min-w-0">
                <div
                    className="
                        grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-11
                        gap-x-4 gap-y-2
                        w-full min-w-0
                    "
                >
                    {items.map((item, idx) => (
                        <div key={idx} className="text-center px-1">
                            {/* Número */}
                            <div
                                className={[
                                    "text-xs md:text-sm lg:text-base",      // 👈 mismo tamaño para todos
                                    item.highlight ? "font-bold" : "font-semibold",
                                    "leading-snug",
                                    item.color,
                                ].join(" ")}
                            >
                                {fmt.format(Number(item.value || 0))}
                            </div>

                            {/* Etiqueta */}
                            <div className="text-[11px] md:text-xs text-gray-600 leading-snug">
                                {item.label}
                            </div>

                            {/* Tarifa (si aplica) */}
                            {item.tarifa !== undefined && (
                                <div
                                    className={`text-[10px] mt-0.5 ${item.tarifa > 0 ? "text-green-600" : "text-gray-400"
                                        }`}
                                >
                                    {item.tarifa > 0
                                        ? `$${Number(item.tarifa).toFixed(4)}/min`
                                        : "Sin tarifa"}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}